__turbopack_context__.v({
  "aboutCookies": "ORNcuG_aboutCookies",
  "active": "ORNcuG_active",
  "closing": "ORNcuG_closing",
  "cookie_badge": "ORNcuG_cookie_badge",
  "cookie_badgeimage": "ORNcuG_cookie_badgeimage",
  "cookie_badgetext": "ORNcuG_cookie_badgetext",
  "cookiescriptButtonBlue": "ORNcuG_cookiescriptButtonBlue",
  "cookiescriptButtonWhite": "ORNcuG_cookiescriptButtonWhite",
  "cookiescript_accept": "ORNcuG_cookiescript_accept",
  "cookiescript_buttons": "ORNcuG_cookiescript_buttons",
  "cookiescript_category": "ORNcuG_cookiescript_category",
  "cookiescript_category_control": "ORNcuG_cookiescript_category_control",
  "cookiescript_category_cookies_button": "ORNcuG_cookiescript_category_cookies_button",
  "cookiescript_category_cookies_hidden": "ORNcuG_cookiescript_category_cookies_hidden",
  "cookiescript_category_info": "ORNcuG_cookiescript_category_info",
  "cookiescript_category_main": "ORNcuG_cookiescript_category_main",
  "cookiescript_checkbox": "ORNcuG_cookiescript_checkbox",
  "cookiescript_checkbox_label": "ORNcuG_cookiescript_checkbox_label",
  "cookiescript_checkboxs": "ORNcuG_cookiescript_checkboxs",
  "cookiescript_close": "ORNcuG_cookiescript_close",
  "cookiescript_content": "ORNcuG_cookiescript_content",
  "cookiescript_cookiescriptlink": "ORNcuG_cookiescript_cookiescriptlink",
  "cookiescript_description": "ORNcuG_cookiescript_description",
  "cookiescript_gear": "ORNcuG_cookiescript_gear",
  "cookiescript_header": "ORNcuG_cookiescript_header",
  "cookiescript_main": "ORNcuG_cookiescript_main",
  "cookiescript_main_info": "ORNcuG_cookiescript_main_info",
  "cookiescript_manage": "ORNcuG_cookiescript_manage",
  "cookiescript_manage_wrap": "ORNcuG_cookiescript_manage_wrap",
  "cookiescript_manageicon": "ORNcuG_cookiescript_manageicon",
  "cookiescript_pre_header": "ORNcuG_cookiescript_pre_header",
  "cookiescript_readmore": "ORNcuG_cookiescript_readmore",
  "cookiescript_reject": "ORNcuG_cookiescript_reject",
  "cookiescript_reportlink": "ORNcuG_cookiescript_reportlink",
  "cookiescript_tabs": "ORNcuG_cookiescript_tabs",
  "cookiescript_tabs_buttons": "ORNcuG_cookiescript_tabs_buttons",
  "cookiescript_tabs_footer": "ORNcuG_cookiescript_tabs_footer",
  "cookiescript_tabs_header": "ORNcuG_cookiescript_tabs_header",
  "cookiescript_tabs_wrapper": "ORNcuG_cookiescript_tabs_wrapper",
  "d-block": "ORNcuG_d-block",
  "inputContainer": "ORNcuG_inputContainer",
  "none": "ORNcuG_none",
  "title": "ORNcuG_title",
  "wrapperFadeSlideIn": "ORNcuG_wrapperFadeSlideIn",
  "wrapperFadeSlideOut": "ORNcuG_wrapperFadeSlideOut",
});
